/* SCF mega menu layer: close button, mobile drill-down screens, chip expander, click tracking. */
(function () {
  function track(link, level) {
    var payload = { event: 'menu_click', menu_level: level, menu_title: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80), link_url: link.getAttribute('href') || '' };
    if (window.dataLayer && typeof window.dataLayer.push === 'function') window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') window.gtag('event', 'menu_click', payload);
  }

  var drawer = document.getElementById('NavDrawer');
  var siteHeader = document.getElementById('SiteHeader');
  var modalHost = drawer && drawer.closest('.shopify-section-group-header-group');
  if (!modalHost || !siteHeader || !modalHost.contains(siteHeader)) modalHost = null;
  var modalAttributes = null;
  var SLIDE_MS = 280;
  var handoffTimer = null;
  var focusableSelector = 'a[href], button, input, select, textarea, [tabindex]';

  function mobileLayout() { return window.innerWidth <= 768; }

  function visibleControl(el) {
    if (!el || !el.isConnected) return false;
    for (var p = el; p; p = p.parentElement) {
      var style = window.getComputedStyle(p);
      if (p.hidden || p.hasAttribute('inert') || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    }
    return true;
  }

  function headerControls() {
    return siteHeader ? Array.prototype.filter.call(siteHeader.querySelectorAll(focusableSelector), function (el) {
      return !el.disabled && el.tabIndex >= 0 && visibleControl(el);
    }) : [];
  }

  function headerMenuButton() {
    return headerControls().find(function (el) { return el.classList.contains('js-drawer-open-nav'); });
  }

  function focusWithoutScroll(el) {
    if (!el || !el.focus) return;
    var positions = [], parent = el.parentElement;
    while (parent) { positions.push([parent, parent.scrollTop, parent.scrollLeft]); parent = parent.parentElement; }
    var x = window.scrollX, y = window.scrollY;
    try { el.focus({ preventScroll: true }); } catch (err) { el.focus(); }
    positions.forEach(function (p) { p[0].scrollTop = p[1]; p[0].scrollLeft = p[2]; });
    if (window.scrollX !== x || window.scrollY !== y) window.scrollTo(x, y);
  }

  function activeScreen() {
    if (!drawer) return null;
    var screens = drawer.querySelectorAll('.collapsible-content.is-screen.is-open');
    return screens.length ? screens[screens.length - 1] : null;
  }

  function revealFocusedRow(el) {
    var sc = activeScreen() || (drawer && drawer.querySelector('.drawer__scrollable'));
    if (!sc || !sc.contains(el)) return; /* header and footer controls stay fixed */
    var viewport = sc.getBoundingClientRect(), row = el.getBoundingClientRect();
    var top = viewport.top + sc.clientTop, bottom = top + sc.clientHeight;
    if (row.top < top) sc.scrollTop += row.top - top;
    else if (row.bottom > bottom) sc.scrollTop += row.bottom - bottom;
  }

  /* Covered rows must not receive keyboard focus or screen-reader navigation. */
  function updateScreenInteraction() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-scf-menu-blocked]').forEach(function (el) {
      el.removeAttribute('inert'); el.removeAttribute('data-scf-menu-blocked');
    });
    drawer.querySelectorAll('.collapsible-content').forEach(function (panel) {
      panel.toggleAttribute('inert', !panel.classList.contains('is-open'));
    });
    var node = activeScreen(), sc = drawer.querySelector('.drawer__scrollable');
    while (node && node !== sc && node !== drawer) {
      var parent = node.parentElement;
      if (!parent) break;
      Array.prototype.forEach.call(parent.children, function (sibling) {
        if (sibling !== node && !sibling.hasAttribute('inert')) {
          sibling.setAttribute('inert', ''); sibling.setAttribute('data-scf-menu-blocked', '');
        }
      });
      node = parent;
    }
  }

  /* ---------- mobile drill-down screens (2026-09-18) ----------
     Every level with a sub-list opens as its own screen, placed where the shopper is looking. The container
     behind it keeps its scroll position and is frozen; the screen scrolls on its own, vertically only; back
     returns to the container exactly as it was. Handled ahead of the theme's accordion (capture phase), which
     would otherwise resize the scroll area under the slide. */
  function scrollerOf(panel) {
    var p = panel.parentElement;
    while (p && p !== drawer) {
      if (p.classList.contains('is-screen') || p.classList.contains('drawer__scrollable')) return p;
      p = p.parentElement;
    }
    return drawer ? drawer.querySelector('.drawer__scrollable') : null;
  }
  function offsetWithin(panel, sc) {
    var t = 0, el = panel.offsetParent;
    while (el && el !== sc && el !== document.body) { t += el.offsetTop; el = el.offsetParent; }
    return el === sc ? t : 0;
  }
  function openScreen(trig, panel) {
    var sc = scrollerOf(panel); if (!sc) return;
    clearTimeout(panel._scfClose);
    var at = sc.scrollTop, h = sc.clientHeight, off = offsetWithin(panel, sc);
    panel.style.setProperty('--scf-screen-top', (at - off) + 'px');
    panel.style.setProperty('--scf-screen-h', h + 'px');
    panel.classList.add('is-screen');
    panel.scrollTop = 0; panel.scrollLeft = 0; sc.scrollLeft = 0;
    trig.classList.add('is-open'); trig.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open'); panel.setAttribute('aria-hidden', 'false');
    sc.classList.add('scf-nav-locked');
    sc.scrollTop = at;
    updateScreenInteraction();
    focusWithoutScroll(panel.querySelector('.mobile-nav__back'));
  }
  function closeScreen(trig, panel, returnFocus) {
    var sc = scrollerOf(panel);
    /* anything open deeper inside this screen goes with it */
    panel.querySelectorAll('.collapsible-content.mobile-nav__sublist.is-open').forEach(function (deep) {
      var item = deep.closest('.mobile-nav__item'), t = item && item.querySelector('.collapsible-trigger');
      if (t) closeScreen(t, deep, false);
    });
    if (trig) { trig.classList.remove('is-open'); trig.setAttribute('aria-expanded', 'false'); }
    panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true');
    if (sc) sc.classList.remove('scf-nav-locked');
    updateScreenInteraction();
    if (returnFocus !== false) focusWithoutScroll(trig);
    clearTimeout(panel._scfClose);
    panel._scfClose = setTimeout(function () {
      if (panel.classList.contains('is-open')) return; /* reopened in the meantime */
      panel.classList.remove('is-screen');
      panel.style.removeProperty('--scf-screen-top'); panel.style.removeProperty('--scf-screen-h'); panel.style.height = '';
    }, SLIDE_MS);
  }
  function screenFor(trig) {
    var item = trig.closest('.mobile-nav__item');
    return item && item.querySelector(':scope > .collapsible-content.mobile-nav__sublist');
  }

  /* everything back to the first screen; only ever runs while the drawer is closed */
  var resetTimer = null;
  function resetDrawer() {
    if (!drawer || drawer.classList.contains('drawer--is-open')) return;
    drawer.querySelectorAll('.collapsible-trigger').forEach(function (t) { t.classList.remove('is-open'); t.setAttribute('aria-open', 'false'); t.setAttribute('aria-expanded', 'false'); });
    drawer.querySelectorAll('.collapsible-content').forEach(function (c) {
      clearTimeout(c._scfClose);
      c.classList.remove('is-open'); c.classList.remove('is-screen');
      c.setAttribute('aria-hidden', 'true');
      c.style.height = ''; c.style.removeProperty('--scf-screen-top'); c.style.removeProperty('--scf-screen-h');
      c.scrollTop = 0; c.scrollLeft = 0;
    });
    drawer.querySelectorAll('.scf-nav-locked').forEach(function (s) { s.classList.remove('scf-nav-locked'); });
    var sc = drawer.querySelector('.drawer__scrollable'); if (sc) { sc.scrollTop = 0; sc.scrollLeft = 0; }
    updateScreenInteraction();
  }
  function labelButtons(open) {
    document.querySelectorAll('.js-drawer-open-nav').forEach(function (b) {
      b.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); b.setAttribute('aria-expanded', String(open));
    });
  }

  function syncMenuState(open) {
    labelButtons(open);
    document.documentElement.classList.toggle('scf-menu-open', open && mobileLayout());
    if (!modalHost) return;
    if (open && mobileLayout()) {
      if (!modalAttributes) {
        modalAttributes = {};
        ['role', 'aria-modal', 'aria-label'].forEach(function (name) { modalAttributes[name] = modalHost.getAttribute(name); });
      }
      modalHost.setAttribute('role', 'dialog'); modalHost.setAttribute('aria-modal', 'true');
      if (!modalHost.hasAttribute('aria-label') && !modalHost.hasAttribute('aria-labelledby')) modalHost.setAttribute('aria-label', 'Navigation menu');
    } else if (modalAttributes) {
      Object.keys(modalAttributes).forEach(function (name) {
        if (modalAttributes[name] === null) modalHost.removeAttribute(name);
        else modalHost.setAttribute(name, modalAttributes[name]);
      });
      modalAttributes = null;
    }
  }
  resetDrawer();
  if (drawer && window.MutationObserver) {
    var wasOpen = drawer.classList.contains('drawer--is-open');
    syncMenuState(wasOpen);
    new MutationObserver(function () {
      var open = drawer.classList.contains('drawer--is-open');
      if (open !== wasOpen) syncMenuState(open);
      if (open) clearTimeout(resetTimer);
      if (wasOpen && !open) { clearTimeout(resetTimer); resetTimer = setTimeout(resetDrawer, 500); }
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  /* The drawer starts below the actual header and ends at the visible viewport. */
  function resizeScreens() {
    if (!drawer) return;
    drawer.querySelectorAll('.collapsible-content.is-screen.is-open').forEach(function (panel) {
      var sc = scrollerOf(panel); if (sc) panel.style.setProperty('--scf-screen-h', sc.clientHeight + 'px');
    });
  }
  function closeForDesktop() {
    clearTimeout(handoffTimer); handoffTimer = null;
    if (window.theme && theme.NavDrawer && theme.NavDrawer.isOpen) {
      theme.NavDrawer.close(null, { returnFocus: false });
      focusWithoutScroll(headerControls().find(function (el) { return !el.classList.contains('js-drawer-open-nav'); }));
    }
  }

  function measureMenuGeometry() {
    if (!drawer || !mobileLayout()) return;
    var viewport = window.visualViewport;
    var viewportTop = viewport ? viewport.offsetTop : 0;
    var viewportBottom = viewportTop + (viewport ? viewport.height : window.innerHeight);
    var headerBottom = siteHeader ? siteHeader.getBoundingClientRect().bottom : viewportTop;
    var top = Math.min(viewportBottom, Math.max(viewportTop, headerBottom));
    drawer.style.setProperty('--scf-menu-top', top + 'px');
    drawer.style.setProperty('--scf-menu-height', Math.max(0, viewportBottom - top) + 'px');
  }

  function refreshMenuLayout() {
    if (!drawer || !drawer.classList.contains('drawer--is-open')) return;
    if (!mobileLayout()) { closeForDesktop(); return; }
    measureMenuGeometry();
    resizeScreens();
  }
  window.addEventListener('resize', refreshMenuLayout);
  window.addEventListener('scroll', refreshMenuLayout, { passive: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', refreshMenuLayout);
    window.visualViewport.addEventListener('scroll', refreshMenuLayout);
  }
  if (drawer && window.ResizeObserver) {
    var scrollArea = drawer.querySelector('.drawer__scrollable');
    var menuObserver = new ResizeObserver(refreshMenuLayout);
    if (scrollArea) menuObserver.observe(scrollArea);
    if (siteHeader) menuObserver.observe(siteHeader);
    document.querySelectorAll('.announcement-bar, .toolbar').forEach(function (el) { menuObserver.observe(el); });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer || !drawer.classList.contains('drawer--is-open')) return;
    var choices = headerControls().concat(Array.prototype.filter.call(drawer.querySelectorAll(focusableSelector), function (el) {
      return !el.disabled && el.tabIndex >= 0 && visibleControl(el);
    }));
    choices = choices.filter(function (el, index) { return choices.indexOf(el) === index; });
    if (!choices.length) return;
    e.preventDefault(); e.stopPropagation();
    var index = choices.indexOf(document.activeElement);
    var next = index < 0 ? (e.shiftKey ? choices.length - 1 : 0) : (index + (e.shiftKey ? -1 : 1) + choices.length) % choices.length;
    focusWithoutScroll(choices[next]);
    revealFocusedRow(choices[next]);
  }, true);

  /* The theme's own close() keeps a 500ms timer that later focuses the hamburger and flips its state, even if the
     menu was reopened in the meantime; focusing also scrolls the page. This replacement does the same work with a
     timer that stands down when the menu is open again, and focuses without scrolling, so closing leaves the page
     where it was. The theme bound its original close to the X at start-up, so the X is routed here (below). */
  var closeTimer = null;
  document.addEventListener('drawerOpen.NavDrawer', function () {
    clearTimeout(closeTimer); clearTimeout(resetTimer); clearTimeout(handoffTimer);
    handoffTimer = null;
    if (!mobileLayout()) {
      /* open() still has to bind its events after dispatching this event. */
      setTimeout(function () { if (!mobileLayout()) closeForDesktop(); }, 0);
      return;
    }
    document.documentElement.classList.remove('js-drawer-closing');
    syncMenuState(true);
    refreshMenuLayout();
    updateScreenInteraction();
    var screen = activeScreen();
    focusWithoutScroll(screen ? screen.querySelector('.mobile-nav__back') : headerMenuButton());
  });
  function installClose() {
    if (!window.theme || !theme.NavDrawer) return false;
    if (theme.NavDrawer._scfClose) return true;
    var nd = theme.NavDrawer;
    nd._scfClose = true;
    nd.close = function (evt, options) {
      if (!this.isOpen) return;
      if (evt && evt.target && evt.target.closest) {
        if (evt.target.closest('.js-drawer-close')) { /* the X */ }
        else if (evt.target.closest('.drawer')) return;
      }
      if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
      theme.utils.prepareTransition(this.drawer, function () { this.drawer.classList.remove(this.config.activeDrawer); }.bind(this));
      this.drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove(this.config.openClass);
      document.documentElement.classList.add(this.config.closingClass);
      syncMenuState(false);
      var returnFocus = !options || options.returnFocus !== false;
      var source = this.activeSource;
      var self = this;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        document.documentElement.classList.remove(self.config.closingClass);
        if (self.isOpen || !returnFocus || document.documentElement.classList.contains(self.config.openClass)) return;
        focusWithoutScroll(source);
      }, 500);
      this.isOpen = false;
      theme.a11y.removeTrapFocus({ container: this.drawer, namespace: 'drawer_focus' });
      this.unbindEvents();
    };
    return true;
  }
  if (!installClose()) {
    document.addEventListener('DOMContentLoaded', installClose);
    var tries = 0, poll = setInterval(function () { if (installClose() || ++tries > 40) clearInterval(poll); }, 250);
  }

  function handoffToTarget(target) {
    if (!target || !window.theme || !theme.NavDrawer) return false;
    clearTimeout(handoffTimer);
    theme.NavDrawer.close(null, { returnFocus: false });
    handoffTimer = setTimeout(function () {
      handoffTimer = null;
      if (!theme.NavDrawer.isOpen && target.isConnected) target.click();
    }, 350);
    return true;
  }

  function handoffTo(selector) {
    return handoffToTarget(Array.prototype.find.call(document.querySelectorAll(selector), function (el) {
      return !el.closest('#NavDrawer') && visibleControl(el);
    }));
  }

  /* capture phase: the X and the hamburger (if ever tapped while open) close through the replacement close;
     the Search products row closes the menu and opens the header search; screen triggers bypass the accordion */
  document.addEventListener('click', function (e) {
    var x = e.target.closest('#NavDrawer .js-drawer-close');
    if (x && window.theme && theme.NavDrawer) { e.preventDefault(); e.stopPropagation(); theme.NavDrawer.close(); return; }
    var navBtn = e.target.closest('.js-drawer-open-nav');
    if (navBtn && !mobileLayout()) {
      e.preventDefault(); e.stopPropagation(); closeForDesktop(); return;
    }
    if (navBtn && window.theme && theme.NavDrawer && theme.NavDrawer.isOpen) {
      e.preventDefault(); e.stopPropagation();
      theme.NavDrawer.close();
      return;
    }
    if (navBtn) measureMenuGeometry(); /* before the theme forces its entrance layout */
    var headerAction = e.target.closest('#SiteHeader .js-search-header, #SiteHeader .js-drawer-open-cart');
    if (headerAction && window.theme && theme.NavDrawer && (theme.NavDrawer.isOpen || handoffTimer !== null)) {
      if (handoffToTarget(headerAction)) { e.preventDefault(); e.stopPropagation(); }
      return;
    }
    var action = e.target.closest('[data-scf-menu-search], [data-scf-menu-cart]');
    if (action) {
      var selector = action.hasAttribute('data-scf-menu-cart') ? '.js-drawer-open-cart' : '.js-search-header';
      if (handoffTo(selector)) { e.preventDefault(); e.stopPropagation(); }
      return;
    }
    var trig = e.target.closest('#NavDrawer .collapsible-trigger');
    if (!trig || !mobileLayout()) return;
    var panel = screenFor(trig);
    if (!panel) return;
    e.preventDefault(); e.stopPropagation();
    if (trig.classList.contains('is-open')) closeScreen(trig, panel); else openScreen(trig, panel);
  }, true);

  document.addEventListener('click', function (e) {
    var close = e.target.closest('.megamenu__close');
    if (close) { var d = close.closest('details'); if (d) d.removeAttribute('open'); return; }
    var back = e.target.closest('.mobile-nav__back');
    if (back) {
      var panel = back.closest('.collapsible-content'); var item = panel && panel.closest('.mobile-nav__item');
      var trigger = item && item.querySelector('.collapsible-trigger');
      if (trigger) trigger.click();
      return;
    }
    var more = e.target.closest('.device-chips__more');
    if (more) { var row = more.closest('.device-chips__row'); if (row) row.classList.add('is-expanded'); more.remove(); return; }
    var link = e.target.closest('a');
    if (!link) return;
    if (link.closest('#NavDrawer .mobile-nav')) track(link, 'mobile');
    else if (link.closest('.site-nav')) track(link, link.getAttribute('data-menu-level') || 'desktop');
    else if (link.closest('.device-chips')) track(link, 'chooser');
  });
})();
